import { Component, OnInit } from '@angular/core';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router } from '@angular/router';
import { QuestionnaireService } from '../../services/questionnaire-service/questionnaire.service';
import { PatientDataService } from '../../services/patient-data/patient-data.service';
import { LoggingService } from '../../services/logging-service/logging.service';
import { MatSnackBar } from '../../../../node_modules/@angular/material';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';
import { forEach } from '../../../../node_modules/@angular/router/src/utils/collection';
import { HomeCardModel } from '../../models/home-card-model';
import { HomeCardService } from '../../services/home-card-service/home-card.service';

@Component({
  selector: 'app-mybirthplan-view',
  templateUrl: './portal-mybirthplan-view.component.html',
  styleUrls: ['./portal-mybirthplan-view.component.css']
})
export class PortalMyBirthPlanViewComponent implements OnInit {
  
  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private router: Router,
    private questionnaireService: QuestionnaireService, private patientService: PatientDataService,
    private loggingService: LoggingService, private snackBar: MatSnackBar,
    private userSession: UserSessionService, private homeCardService: HomeCardService) { }

  public complete: boolean;
  public loaded: boolean = false;
  public error: boolean = false;
  public submitted: boolean = false;
  public questionnaireData: any;
  public patient: any;
  public booked: boolean;
  public showHelpText: boolean = false;
  public mybirthPlanCard: HomeCardModel

  ngOnInit() {
    
    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);

    if (typeof this.userSession.homeCards === 'undefined' || this.userSession.homeCards.length == 0) {
      this.homeCardService.loadHomeCards();
    }

    this.mybirthPlanCard = this.userSession.homeCards.find(x => x.CardName === 'MyBirthPlan');

    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(
      this.appConfigService.ApplicationName, this.mybirthPlanCard.Title, null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, true, true));

    this.loggingService.log('Getting patient. Checking booking status.', this.appConfigService.LogToConsole);
    this.patientService.getPatient(this.appConfigService.PatientId).subscribe(response => {
      this.patient = response.json();

      if (this.patient.CurrentPregnancy) {
        this.loggingService.log('Getting Birth Plan definition', this.appConfigService.LogToConsole);
        this.questionnaireService.getBirthPlanEpaDefinition().map(response => response.json()).subscribe(response => {
          this.questionnaireData = response;
          this.loggingService.log('Have Birth Plan definition', this.appConfigService.LogToConsole);
          this.questionnaireData.QuestionnaireDefinitionList.forEach(questionnaire => {
            questionnaire.QuestionDefinitionList.forEach(question => {
              question.AnswerDefinitionList.forEach(answer => {
                answer.TextAnswer = answer.TextAnswer;
                if (answer.AnswerId == answer.PatientAnswer) {

                  // We are reselecting answers that have been previously chosen
                  // If the answer text matches the answer, then we know that
                  // it should be checked. If it doesn't, then we know it is
                  // a text answer, associated with the answer and this will be bound automatically.
                  if (answer.AnswerText == answer.Answer) {
                    answer.Selected = true;
                  }
                }
              });
            });
          });
          this.loaded = true;
        }, (error => { this.handleError(error); }));
      }
      else {
        this.booked = true;
        this.loaded = true;
      }
    }, (error => { this.handleError(error); }));
  }

  toggleHelpText() {
    this.showHelpText = !this.showHelpText;
  }

  inputChange(answerDefinition: any, event: any) {
    if (answerDefinition.QuestionTypeId == 35) {
      console.log(event.keyCode)
      if (event.keyCode == 69 || event.keyCode == 190) {
        event.preventDefault();
        return 0;
      }

      if (event.keyCode == 189) {
        event.preventDefault();
        return 0;
      }

      // numeric keypad or top row
      if (event.keyCode != 8 && (event.keyCode < 96 || event.keyCode > 105)) {
        if (event.keyCode != 8 && (event.keyCode < 47 || event.keyCode > 57)) {
          event.preventDefault();
          return 0;
        }
      }
    }
  }

  getType(answerDefinition: any) {
    if (answerDefinition.QuestionTypeId == 35)
      return "number"; // Positive only

    if (answerDefinition.QuestionTypeId == 4)
      return "date";

    return "text";
  }


  // An answer has been changed
  changeAnswer(answerDefinition: any, answerDefinitions: any, event: Event) {
    console.log('');
    // If this is a single answer - deselect all others
    if (answerDefinition.SingleAnswer == true) {
      answerDefinitions.forEach(definition => {
        // Deselect all other answers that do not match the current selection
        if (definition != answerDefinition) {
          definition.Selected = false;
          definition.AnswerText = null;
          console.log('Reset answer (single answer): ' + definition.Answer);
        }
      });

      // If the current selection itself is not selected, then reset that one also
      if (answerDefinition.Selected == false) {
        answerDefinition.AnswerText = null;
        console.log('Reset answer (self): ' + answerDefinition.Answer);
      }
      else {
        answerDefinition.AnswerText = answerDefinition.Answer;
        console.log('AnswerText set to answer: ' + answerDefinition.Answer);
      }
    }
    else {
      // find any others that ARE single answer, and reset those as this answer is a multiple
      answerDefinitions.forEach(definition => {
        // Deselect all other answers that do not match the current selection
        if (definition.SingleAnswer == true) {
          definition.Selected = false;
          definition.AnswerText = null;
          console.log('Reset answer (single answer): ' + definition.Answer);
        }
      });

      // This is not a single answer. If it is not selected, then reset it.
      if (answerDefinition.Selected == false) {
        answerDefinition.AnswerText = null;
        answerDefinition.AnswerMemoText = null;
        console.log('Reset answer (not single answer): ' + answerDefinition.Answer);
      }
      else {
        // This answer is selected.
        answerDefinition.AnswerText = answerDefinition.Answer;
        console.log('AnswerText set to answer: ' + answerDefinition.Answer);
      }
    }

    // Remove any answers that should be excluded
    let exclusions: string = answerDefinition.ExcludeAnswers;
    let exclusionsList: string[] = exclusions.split(';');
    for (let exclusion of exclusionsList) {
      for (let answerDefinition of answerDefinitions) {
        if (answerDefinition.AnswerId == exclusion) {
          answerDefinition.Selected = false;
          answerDefinition.AnswerText = null;
        }
      }
    }
  }

  submitQuestionnaire() {
    this.loggingService.log(`Submitting Questionnaire`, this.appConfigService.LogToConsole);
    this.patientService.getPatientId(this.appConfigService.UserName).map(response => response.json()).subscribe((response => {
      this.loaded = false;
      let patientId = response.PatientId;
      this.patientService.getCurrentPregnancyId(patientId).map(response => response.json()).subscribe(response => {
        let pregnancyId = response.CurrentPregnancyId;
        this.questionnaireData.PregnancyId = pregnancyId;
        this.questionnaireData.PatientId = patientId;
        console.log(this.questionnaireData);
        this.questionnaireService.postBirthPlanQuestionnaireDefinition(this.questionnaireData).subscribe(response => {
          this.questionnaireData = response;
          this.submitted = true;
          this.loaded = true;
          this.loggingService.log("Submission completed", this.appConfigService.LogToConsole);
        }, (error => { this.handleError(error) }));
      }, (error => { this.handleError(error) }));
    }), (error => this.handleError(error)));
  }

  handleError(error: HttpErrorResponse) {
    this.loggingService.log(`ERROR while getting EPA definition: ${error.message}`, this.appConfigService.LogToConsole);

    switch (error.status) {
      case 0:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. You appear to be offline.", "", { duration: 5000 });
        this.loggingService.log("Error - offline", this.appConfigService.LogToConsole);
        break;
      case 401:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Your login has expired.", "", { duration: 5000 });
        this.loggingService.log("Error - login expired", this.appConfigService.LogToConsole);
        this.userSession.logout();
        break;
      case 500:
        this.error = true;
        this.snackBar.open("Sorry, we can't do that. Server error.", "", { duration: 5000 });
        this.loggingService.log("Error - Server error", this.appConfigService.LogToConsole);
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-mybirthplan-view/portal-mybirthplan-view.component.ts